import MegaText from './MegaText'

export default MegaText
